/* import __COLOCATED_TEMPLATE__ from './buyer-right-side-nav.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

const BUTTON_CLASS_NAME = 'SH-c-site-header__shrinking-button';

class BuyerRightSideNavComponent extends Component {
  get className() {
    return BUTTON_CLASS_NAME;
  }

  @action
  onDropdownItemSelected(dropdown) {
    dropdown.actions.close();
  }
}

export default BuyerRightSideNavComponent;
